'use client';
import { useEffect, useState } from 'react';

/**
 *  SMALL_DESKTOP should support heights down to 500px
 */

const MOBILE_WIDTH = 768;
const TABLET_WIDTH = 1150;
const SMALL_DESKTOP_WIDTH = 1350;
const SMALL_DESKTOP_HEIGHT = 820;

export const useResponsive = () => {

  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);
  const [isSmallDesktop, setIsSmallDesktop] = useState(false);
  const [isSmallHeight, setIsSmallHeight] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_WIDTH);
      setIsTablet(window.innerWidth > MOBILE_WIDTH && window.innerWidth <= TABLET_WIDTH);
      setIsDesktop(window.innerWidth > TABLET_WIDTH);
      setIsSmallHeight(window.innerHeight <= SMALL_DESKTOP_HEIGHT);
      const isSmallDesktopWidth = window.innerWidth <= SMALL_DESKTOP_WIDTH && window.innerWidth > TABLET_WIDTH;
      const isSmallDesktopHeight = window.innerHeight <= SMALL_DESKTOP_HEIGHT;
      setIsSmallDesktop(isSmallDesktopWidth && isSmallDesktopHeight);
    };
    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isSmallHeight,
    isSmallDesktop
  };
};
